import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../assets/styles/Timeline.scss";

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "white", color: "rgb(39, 40, 34)" }}
            contentArrowStyle={{ borderRight: "7px solid  white" }}
            date="July 2022 - present"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Classcard (Frontend Engineer)
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Dubai, UAE</h4>
            <p>
              - Primarily managed the user-centric dashboard and booking
              website. <br />- Oversaw customer-oriented applications for the
              dashboard and booking website.
              <br /> - Handled and managed the deployment server, including
              setting up new servers.
              <br /> - Managed a team member and was involved in onboarding new
              developers to the team.
              <br /> - Managed a team member and was involved in onboarding new
              developers to the team.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="March 2022 - July 2022"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              Lumiq.ai (Intern)
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Noida, Uttar Pradesh
            </h4>
            <p>
              - Set up monitoring for a live product using Prometheus and
              Grafana, including configuring alert triggers for surges and
              downtimes.
              <br />
              - Delivered a hands-on session on Docker, highlighting its
              benefits and implementation.
              <br /> - Collaborated closely with the data analytics team to
              learn and contribute to the processes of extracting, transforming,
              and loading data (ETL).
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="March 2022 - March 2022"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              WorldRef (Intern)
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Delhi, India</h4>
            <p>
              - Contributed to bootstrapping the web repository for the
              customer-facing dashboard.
              <br /> - Participated in final testing and bug fixing of the user
              application.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="June 2021 - September 2021"
            iconStyle={{ background: "#5000ca", color: "rgb(39, 40, 34)" }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">
              SSDN Technologies (AWS Architect Intern, MERN Stack Intern)
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Gurugram, Haryana
            </h4>
            <p>
              - Contributed to the primary website enhancing user experience and
              speed optimisations.
              <br /> - Worked on enhancing the CI/CD pipeline for streamlined
              deployment.
              <br /> - Studied the fundamentals of the MERN stack and
              implemented them in a live environment.
              <br /> - Gained knowledge of AWS basics, including S3 buckets, IAM
              roles, and Auto Scaling Groups (ASGs).
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
